import {Component, ViewChild} from '@angular/core';
import {TipoSolicitudSisben} from "../../../shared/interface/sisben";
import {TramitesSisben} from "../../../shared/classes/TramitesSisben";
import {TramiteSisbenComponent} from "../../../components/tramite-sisben/tramite-sisben.component";
import {
  TramRegistroSolicitudService
} from "../../../../../../tramitantes/src/app/services/tramiteRegistroSolicitud.service";

@Component({
  selector: 'app-agregar-miembro',
  standalone: true,
  imports: [
    TramiteSisbenComponent
  ],
  providers: [
    {provide: TramitesSisben, useExisting: AgregarMiembroComponent}
  ],
  template: `
    <app-tramite-sisben [tipoSolicitud]="tipoSolicitud" [titulo]="titulo"/>
  `
})
export class AgregarMiembroComponent extends TramitesSisben {


  @ViewChild(TramiteSisbenComponent, {static: true}) tramiteSisbenComponent!: TramiteSisbenComponent;


  constructor(protected tramiteRegistroService: TramRegistroSolicitudService) {
    super("Agregar miembro",
      TipoSolicitudSisben.AGREGAR_MIEMBRO,
      tramiteRegistroService);
  }

  public override modificar(event: any) {
    throw new Error('Method not implemented.');
  }

  public override eliminar(event: any) {
    throw new Error('Method not implemented.');
  }

  public override validate(): boolean {
    return true;
  }

  public override buildParameters(): any {
    if(!this.tramiteSisbenComponent.jefeHogar)
      return null;
    const obj: any = {}
    // @ts-ignore
    this.props().parametros?.forEach((item) => {
      obj[item] = (this.tramiteSisbenComponent.jefeHogar as any)[item] ?? "";
    });
    return obj;
  }

}
